import React from 'react';

// Import necessary components
import { Lightbox, PageSidebar, PageTitle } from '../../../components';

// Import icons for visual representation
import { FaCheck, FaCircleNotch, FaStar } from 'react-icons/fa';

// Import useLocation to access route state
import { useLocation } from 'react-router-dom';



const PortfolioSingle = () => { 

  // Get portfolio details passed via router state
  const location = useLocation();  
  const portfolio = location.state; 

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={'Portfolio Single'} page={'Portfolio Single'} />

      <section className='portfolio-single page-single'>

        <div className='portfolio-info page-info'>

          {/* portfolio Image Section */}
          <div className='image'>
            <img src={portfolio.image} alt={portfolio.title} />
          </div>

          <div className='content'>

            {/* portfolio Title */}
            <h3 className='main-heading'>{portfolio.title}</h3>

            {/* portfolio Description */}
            {portfolio.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* portfolio Image Gallery */}
            <Lightbox images={portfolio.gallery} />

            {/* services offered Section */}
            <div className='sub-section'>

              {/* Introduction to services offered */}
              <h3 className='sub-heading'>Services Offered:</h3>
              <p>Explore the delightful range of offerings we provided for the {portfolio.title} project, from custom cakes to handcrafted pastries and signature baked treats.</p>

              {/* List of services offered */}
              <ul>
                {portfolio.services.map((challenge, index) => {
                  return <li key={index}><FaCheck className='icon' />{challenge}</li>
                })}
              </ul>

            </div>

            {/* Customization Section */}
            <div className='sub-section'>

              {/* Customization Intro */}
              <h3 className='sub-heading'>Customization:</h3>
              <p>Discover the personalized touches we added to the {portfolio.title} project, offering custom flavors, designs, and packaging to make each treat truly unique.</p>

              {/* List of Customization Options */}
              <ul>
                {portfolio.customization.map((solution, index) => {
                  return <li key={index}><FaStar className='icon' />{solution}</li>
                })}
              </ul>

            </div>

            {/* Portfolio Results Section */}
            <div className='sub-section'>

              {/* Portfolio Results Intro */}
              <h3 className='sub-heading'>Results:</h3>
              <p>The {portfolio.title} project delighted customers with beautifully crafted treats, exceptional flavors, and an unforgettable bakery experience.</p>

              {/* List of Portfolio Results */}
              <ul>
                {portfolio.results.map((result, index) => {
                  return <li key={index}><FaCircleNotch className='icon' />{result}</li>
                })}
              </ul>

            </div>

          </div> 
        
        </div> 

        {/* Sidebar with portfolio details */}
        <PageSidebar
          heading={'portfolio'}
          details={portfolio.details}
        />

      </section>

    </> 
  );
}

export default PortfolioSingle;